module.exports = __webpack_public_path__ + "img/adv_cn.52b3081f.png";